import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

if ('serviceWorker' in navigator && 'PushManager' in window) {
  navigator.serviceWorker.getRegistrations()
    .then(registrations => {
      if (registrations.length === 0) {
        navigator.serviceWorker.register('/service-worker.js')
          .then(registration => {
            // console.log('Service Worker registered:', registration);
          })
          .catch(err => {
            // console.error('Service Worker registration failed:', err);
          });
      } else {
        // console.log('Service Worker already registered');
      }
    })
    .catch(err => {
      console.error('Error checking service worker registrations:', err);
    });
}

navigator.serviceWorker.addEventListener('message', event => {
    if (event.data.type === 'PLAY_NOTIFICATION_SOUND') {
        const soundUrl = event.data.soundUrl;
        const audio = new Audio(soundUrl);
        audio.play().catch(error => {
            console.error('Error playing sound:', error);
        });
    }
});




